import { useQuery } from '@hooks/reactQuery';

import { getNetworkElementConfigurationsMiddlewares } from '@api/manageNetworkElementConfigurations';

import { optionsFormattedBySystemId } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENT_CONFIGURATION_MIDDLEWARES } from '@constants/queryKeys';

interface IUseQueryNetworkElementConfigurationMiddlewareReturned {
	middlewareOptions: TSelectOption[];
	isLoadingMiddlewareOptions: boolean;
}

const useQueryNetworkElementConfigurationMiddleware = (): IUseQueryNetworkElementConfigurationMiddlewareReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENT_CONFIGURATION_MIDDLEWARES],
		queryFn: getNetworkElementConfigurationsMiddlewares,
		select: optionsFormattedBySystemId,
		...refetchOptions,
	});

	return {
		middlewareOptions: data || [],
		isLoadingMiddlewareOptions: (isLoading && !!data)
			|| isFetching,
	};
};

export default useQueryNetworkElementConfigurationMiddleware;
